// testTeoricaPreview.js — ESPEJO EXACTO de los textos que recibe el alumno en los Tests de teórica,
// para las vistas previas del CRM (Mensajes automáticos → Tests de teórica, ficha → Tests) y del
// simulador de ventas. Funciones PURAS, sin red.
//
// De dónde sale cada cosa (y __tests__/testTeoricaPreview.mirror.test.js lo compara con el backend):
//   - corregir / textoFallos / textoResultadoWhatsApp / AVISO_DEMO  ← aws_lambdas/_shared_test_teorica/puntuacion.js
//   - mensajePregunta / textoCorreccion / textoFinal                ← aws_lambdas/_shared_test_teorica/telegram.js
//   - pantallaAlta / pantallaPregunta / pantallaResultado / pantallaListo ← _shared_test_teorica/flowScreens.js
//   - TEXTOS / testText / CTA del Flow                               ← aws_lambdas/c_testTeoricaCommand/whatsappHandler.js
//   - cuerpo de la plantilla diaria                                  ← SYSTEM_TEMPLATES de aws_lambdas/c_sendTemplate/index.js
//   - prefijo «📩 *Autoescuela* te escribe:» del número compartido   ← aws_lambdas/c_sendMessage/index.js
//   - preguntas de ejemplo + ATRIBUCION_DGT                          ← admin_scripts/test_teorica/dgt/muestra/banco_dgt_publico_muestra.json
// Si cambias un texto en el backend, cámbialo aquí: el test falla hasta que coincidan.
//
// COPIA POR VALOR (fichero idéntico) en apps/conext-ventas/src/simulator/pages/autoescuela/mensajes/
// testTeoricaPreview.js — un test del simulador compara los dos ficheros.

// ── puntuacion.js ────────────────────────────────────────────────────────────────────────────────
export const LETRA = { a: "A", b: "B", c: "C" };

export function corregir(preguntas) {
  const lista = Array.isArray(preguntas) ? preguntas : [];
  let aciertos = 0;
  let sin = 0;
  const falladas = [];
  lista.forEach((p, i) => {
    if (p.r == null || p.r === "") { sin++; falladas.push(i); return; }
    if (p.r === p.c) aciertos++;
    else falladas.push(i);
  });
  const total = lista.length;
  const fallos = total - aciertos;
  const nota = total ? Math.round((aciertos / total) * 100) / 10 : 0;
  return { aciertos, total, fallos, sin_responder: sin, nota, aprobado: total > 0 && fallos <= Math.floor(total * 0.1), falladas };
}

export const fmtNota = (n) => Number(n || 0).toFixed(1).replace(".", ",");

export function recorta(s, max) {
  const t = String(s == null ? "" : s).trim();
  return t.length <= max ? t : `${t.slice(0, Math.max(0, max - 1)).trimEnd()}…`;
}

export function textoFallos(test, porKey, { estilo = "whatsapp", max = 3000 } = {}) {
  const b = (s) => (estilo === "flow" ? `**${s}**` : estilo === "telegram" ? `<b>${s}</b>` : `*${s}*`);
  const esc = (s) => (estilo === "telegram" ? String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : String(s));
  const bloques = [];
  (test.preguntas || []).forEach((p, i) => {
    if (p.r === p.c) return;
    const q = porKey[p.k] || {};
    const correcta = q.opciones && q.opciones[p.c] ? `${LETRA[p.c] || p.c}) ${q.opciones[p.c]}` : (LETRA[p.c] || p.c);
    const tuya = p.r ? (LETRA[p.r] || p.r) : "sin responder";
    const lineas = [
      b(`${i + 1}. ${esc(recorta(q.texto || "Pregunta", 160))}`),
      `Tu respuesta: ${tuya} · Correcta: ${esc(recorta(correcta, 160))}`,
    ];
    if (q.explicacion) lineas.push(esc(recorta(q.explicacion, 220)));
    bloques.push(lineas.join("\n"));
  });
  let out = "";
  let incluidos = 0;
  for (const bl of bloques) {
    const cand = out ? `${out}\n\n${bl}` : bl;
    if (cand.length > max - 60) break;
    out = cand;
    incluidos++;
  }
  if (incluidos < bloques.length) out += `\n\n(+${bloques.length - incluidos} fallo${bloques.length - incluidos === 1 ? "" : "s"} más: los verás en tus próximos tests)`;
  return out;
}

export const AVISO_DEMO = "Este test incluye preguntas de DEMOSTRACIÓN preparadas por Conext: no son del banco oficial de la DGT.";

/** Línea de fuente de las preguntas del test («Fuente: …»), o "" si el banco no la exige. */
export const textoAtribucion = (test) => ((test && Array.isArray(test.atribuciones)) ? test.atribuciones : []).filter(Boolean).join(" · ");

export function textoResultadoWhatsApp({ test, correccion, porKey, demo = false }) {
  const c = correccion;
  const cab = `${c.aprobado ? "✅" : "📚"} *Test de teórica: ${fmtNota(c.nota)}*\n` +
    `Has acertado ${c.aciertos} de ${c.total}${c.aprobado ? ". ¡Aprobado!" : `. Para aprobar el examen ${Math.floor(c.total * 0.1) === 1 ? "se permite 1 fallo" : `se permiten ${Math.floor(c.total * 0.1)} fallos`}.`}`;
  const partes = [cab];
  if (c.fallos) partes.push(`*Repasa estas:*\n\n${textoFallos(test, porKey, { estilo: "whatsapp", max: 3300 })}`);
  else partes.push("Ni un fallo. Sigue así.");
  partes.push("Las que falles volverán en tus próximos tests. Si alguna te parece dudosa, escribe DUDOSA y su número (por ejemplo, DUDOSA 3) y tu autoescuela la revisará. Escribe TEST para hacer otro o STOP TEST para dejar de recibirlos.");
  if (demo) partes.push(`_${AVISO_DEMO}_`);
  const atrib = textoAtribucion(test);
  const cuerpo = partes.join("\n\n");
  // La fuente va SIEMPRE (condición de la DGT): se recorta el cuerpo, nunca la atribución.
  return atrib ? `${recorta(cuerpo, 4096 - atrib.length - 4)}\n\n_${atrib}_` : recorta(cuerpo, 4096);
}

// ── telegram.js ──────────────────────────────────────────────────────────────────────────────────
const TG_MAX_TEXT = 4096;
const TG_MAX_CAPTION = 1024;

export const esc = (s) => String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const encodeCallback = (test_id, idx, r) => `tt|${test_id}|${idx}|${r}`;

export function mensajePregunta({ test_id, idx, total, pregunta, conImagen = false }) {
  const ops = ["a", "b", "c"].filter((l) => pregunta.opciones && pregunta.opciones[l]);
  const lines = [
    `<b>Pregunta ${idx + 1} de ${total}</b>${pregunta.tema ? ` · ${esc(pregunta.tema)}` : ""}`,
    "",
    esc(pregunta.texto),
    "",
    ...ops.map((l) => `<b>${LETRA[l]})</b> ${esc(pregunta.opciones[l])}`),
  ];
  if (String(pregunta.fuente || "").startsWith("demo")) lines.push("", "<i>Pregunta de demostración (no oficial).</i>");
  const text = recorta(lines.join("\n"), conImagen ? TG_MAX_CAPTION : TG_MAX_TEXT);
  return {
    text,
    reply_markup: { inline_keyboard: [ops.map((l) => ({ text: LETRA[l], callback_data: encodeCallback(test_id, idx, l) }))] },
  };
}

export function textoCorreccion({ pregunta, respuesta }) {
  const ok = respuesta === pregunta.correcta;
  const lines = [ok ? `✅ <b>Correcta</b> (${LETRA[respuesta]})` : `❌ <b>Era la ${LETRA[pregunta.correcta]}</b> · tú marcaste la ${LETRA[respuesta]}`];
  if (!ok && pregunta.opciones && pregunta.opciones[pregunta.correcta]) lines.push(esc(pregunta.opciones[pregunta.correcta]));
  if (pregunta.explicacion) lines.push(`<i>${esc(recorta(pregunta.explicacion, 400))}</i>`);
  return lines.join("\n");
}

export function textoFinal({ correccion, racha = 0, demo = false, atribucion = "" }) {
  const c = correccion;
  const nota = c.nota.toFixed(1).replace(".", ",");
  const lines = [
    `${c.aprobado ? "🎉" : "📚"} <b>Nota: ${nota}</b> — ${c.aciertos} de ${c.total}${c.aprobado ? ". ¡Aprobado!" : `. En el examen ${Math.floor(c.total * 0.1) === 1 ? "se permite 1 fallo" : `se permiten ${Math.floor(c.total * 0.1)} fallos`}.`}`,
  ];
  if (c.fallos) lines.push("Las que has fallado volverán en tus próximos tests.");
  if (racha > 1) lines.push(`Racha: ${racha} días seguidos.`);
  lines.push("", "/test otro test · /pausa · /stop");
  if (demo) lines.push("", `<i>${esc(AVISO_DEMO)}</i>`);
  if (atribucion) lines.push("", `<i>${esc(atribucion)}</i>`);
  return lines.join("\n");
}

/** Texto de la pregunta tal como queda en Telegram al contestarla (el mensaje se edita). */
export const textoPreguntaCorregida = ({ test_id, idx, total, pregunta, respuesta }) =>
  `${mensajePregunta({ test_id, idx, total, pregunta }).text}\n\n${textoCorreccion({ pregunta, respuesta })}`;

// ── config.js + flowSpec.js (lo que usan las pantallas) ─────────────────────────────────────────
export const PERMISO_LABEL = {
  AM: "Permiso AM (ciclomotor)", A1: "Permiso A1 (moto 125)", A2: "Permiso A2 (moto)", A: "Permiso A (moto)",
  B: "Permiso B (coche)", BE: "Permiso B+E (remolque)", C1: "Permiso C1 (camión ligero)", C: "Permiso C (camión)",
  CE: "Permiso C+E (trailer)", D1: "Permiso D1 (minibús)", D: "Permiso D (autobús)", DE: "Permiso D+E",
};
export const LONGITUDES = [10, 20, 30];
export const HORAS = Array.from({ length: 17 }, (_, i) => String(i + 7).padStart(2, "0")); // 07…23
const LIMITS = { radioDescription: 300, dropdownTitle: 30, textHeading: 80, textBody: 4096, textCaption: 409, imageBytes: 100 * 1024 };
const MAX_PREGUNTAS = 30;
const PIXEL_PNG_B64 =
  "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
const LETRAS_ID = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const qId = (k) => `P_${LETRAS_ID[Math.floor((k - 1) / 26)]}${LETRAS_ID[(k - 1) % 26]}`;

// ── flowScreens.js ───────────────────────────────────────────────────────────────────────────────
const nonEmpty = (s, fallback) => {
  const t = String(s == null ? "" : s).trim();
  return t || fallback;
};

function opcionesRadio(opciones) {
  return ["a", "b", "c"]
    .filter((l) => opciones && typeof opciones[l] === "string" && opciones[l].trim())
    .map((l) => ({ id: l, title: l.toUpperCase(), description: recorta(opciones[l], LIMITS.radioDescription) }));
}

const b64Bytes = (b64) => Math.floor((String(b64 || "").replace(/=+$/, "").length * 3) / 4);

export function pantallaPregunta({ k, n = k, total, test_id, pregunta, imagenB64 = null }) {
  if (!Number.isInteger(k) || k < 1 || k > MAX_PREGUNTAS) throw new Error(`Pantalla fuera de rango: ${k}`);
  if (!Number.isInteger(n) || n < 1 || n > MAX_PREGUNTAS) throw new Error(`Pregunta fuera de rango: ${n}`);
  const imgOk = !!imagenB64 && b64Bytes(imagenB64) <= LIMITS.imageBytes;
  const demo = String(pregunta.fuente || "").startsWith("demo");
  const avisos = [];
  if (imagenB64 && !imgOk) avisos.push("La imagen de esta pregunta no se ha podido cargar.");
  if (demo) avisos.push("Pregunta de demostración (no oficial).");
  return {
    screen: qId(k),
    data: {
      titulo: `Pregunta ${n} de ${total}`,
      n: String(n),
      tema: nonEmpty(pregunta.tema, "Teórica"),
      enunciado: recorta(nonEmpty(pregunta.texto, "Pregunta"), LIMITS.textBody),
      imagen: imgOk ? imagenB64 : PIXEL_PNG_B64,
      con_imagen: imgOk,
      opciones: opcionesRadio(pregunta.opciones),
      test_id: String(test_id),
      pregunta_id: String(pregunta.key),
      aviso: avisos.length ? avisos.join(" ") : "-",
      con_aviso: avisos.length > 0,
    },
  };
}

export function pantallaResultado({ test, porKey, demo = false }) {
  const c = corregir(test.preguntas);
  const fallos = c.fallos ? textoFallos(test, porKey, { estilo: "flow", max: LIMITS.textBody - 200 }) : "";
  return {
    screen: "RESULTADO",
    data: {
      nota_titulo: recorta(`${fmtNota(c.nota)} · ${c.aprobado ? "Aprobado" : "Sigue practicando"}`, LIMITS.textHeading),
      resumen: c.fallos
        ? `Has acertado ${c.aciertos} de ${c.total}. Abajo tienes las que has fallado con la respuesta correcta. Volverán en tus próximos tests.`
        : `Has acertado las ${c.total}. Ni un fallo.`,
      fallos: fallos || "-",
      con_fallos: !!fallos,
      pie: pieResultado({ demo, atribucion: textoAtribucion(test) }),
      test_id: String(test.test_id),
    },
  };
}

/** Pie de RESULTADO: aviso demo o el de «te mandamos la nota», con la fuente detrás si el banco la exige. */
function pieResultado({ demo, atribucion }) {
  const base = demo ? AVISO_DEMO : "Al cerrar te mandamos la nota también por WhatsApp.";
  if (!atribucion) return recorta(base, LIMITS.textCaption);
  return `${recorta(base, LIMITS.textCaption - atribucion.length - 1)} ${atribucion}`.slice(0, LIMITS.textCaption);
}

export function pantallaAlta({ cfg, actual = {}, permisoAlumno, canales, permisos }) {
  const listaPermisos = (Array.isArray(permisos) && permisos.length ? permisos : ["B"])
    .map((p) => ({ id: p, title: recorta(PERMISO_LABEL[p] || `Permiso ${p}`, LIMITS.dropdownTitle) }));
  const permisoInit = [actual.permiso, permisoAlumno].find((p) => listaPermisos.some((x) => x.id === p)) || listaPermisos[0].id;
  const canalesOpts = canales.map((c) => ({ id: c, title: c === "telegram" ? "Telegram" : "WhatsApp" }));
  const canalInit = canales.includes(actual.canal) ? actual.canal : canales[0];
  const horaInit = HORAS.includes(actual.hora) ? actual.hora : cfg.hora_defecto;
  const longInit = LONGITUDES.includes(Number(actual.longitud)) ? Number(actual.longitud) : cfg.longitud_defecto;
  return {
    screen: "ALTA",
    data: {
      intro: actual.estado
        ? "Cambia lo que quieras y pulsa Guardar."
        : "Cada test son preguntas tipo examen con la corrección al momento. Las que falles vuelven en los siguientes tests hasta que las domines.",
      permisos: listaPermisos,
      permiso_init: permisoInit,
      canales: canalesOpts,
      canal_init: canalInit,
      frecuencias: [{ id: "diaria", title: "Un test cada día" }, { id: "demanda", title: "Solo cuando lo pida" }],
      frecuencia_init: actual.frecuencia === "demanda" ? "demanda" : "diaria",
      horas: HORAS.map((h) => ({ id: h, title: `${h}:00` })),
      hora_init: horaInit,
      longitudes: LONGITUDES.map((n) => ({ id: String(n), title: `${n} preguntas` })),
      longitud_init: String(longInit),
    },
  };
}

export function pantallaListo({ prefs }) {
  const cuando = prefs.frecuencia === "diaria"
    ? `Te mandaremos un test de ${prefs.longitud} preguntas cada día a las ${prefs.hora}:00.`
    : `Escribe TEST cuando quieras uno (${prefs.longitud} preguntas).`;
  return {
    screen: "LISTO",
    data: {
      titulo: "Listo",
      texto: `${cuando} Para cambiarlo escribe AJUSTES TEST y para dejarlo, STOP TEST.`,
    },
  };
}

export function pantallaTelegram({ enlace }) {
  return {
    screen: "TELEGRAM",
    data: {
      titulo: "Último paso: abre Telegram",
      texto: "Pulsa el enlace y luego Iniciar en el bot. Tus tests te llegarán por allí.",
      enlace: String(enlace),
    },
  };
}

// Títulos fijos de las pantallas y botones del pie (flowSpec.js → flow_test_teorica.json).
export const FLOW_UI = {
  alta: { title: "Tests de teórica", footer: "Guardar", labels: { permiso: "Permiso", canal: "Dónde quieres los tests", frecuencia: "Cada cuánto", hora: "Hora del test diario", longitud: "Preguntas por test" } },
  pregunta: { title: "Test de teórica", footer: "Siguiente", label: "Tu respuesta" },
  resultado: { title: "Tu nota", footer: "Cerrar" },
  listo: { title: "Tests de teórica", footer: "Hacer un test ahora" },
  telegram: { title: "Tests por Telegram", footer: "Cerrar", link: "Abrir Telegram" },
};

// ── c_testTeoricaCommand/whatsappHandler.js ─────────────────────────────────────────────────────
export const TEXTOS = {
  alta: "Configura tus tests de teórica: el permiso, si los quieres por WhatsApp o por Telegram, cada cuánto y cuántas preguntas.",
  stop: "Hecho: ya no te mandaremos más tests de teórica. Si quieres volver, escribe TEST.",
  stopSin: "No tenías los tests de teórica activados. Si los quieres, escribe TEST.",
  pausa: "Tests en pausa. Escribe REANUDAR TEST cuando quieras seguir.",
  reanudar: "Tests reactivados. Te llegará el siguiente a tu hora de siempre.",
  telegram: (url) => `Tus tests de teórica van por Telegram${url ? `: ${url}` : ""}. Si prefieres WhatsApp, escribe AJUSTES TEST.`,
};

export const testText = ({ longitud, permiso }) =>
  `Tu test de teórica: ${longitud} preguntas del permiso ${permiso}. Al terminar ves la nota y la corrección de las que falles.`;

export const CTA_ALTA = "Configurar tests";
export const CTA_TEST = "Hacer el test";

// ── c_sendTemplate SYSTEM_TEMPLATES (test_teorica_diario / _trial) ─────────────────────────────
export const PLANTILLA_DIARIA = "Hola {{1}}, tu test de teórica del {{2}} está listo: {{3}} preguntas del permiso {{4}}.\n\nPara dejar de recibirlo, escribe STOP TEST.";
export const PLANTILLA_DIARIA_TRIAL = "📩 *{{1}}* te informa:\n\nHola {{2}}, tu test de teórica del {{3}} está listo: {{4}} preguntas del permiso {{5}}.\n\nPara dejar de recibirlo, escribe STOP TEST.";
export const BOTON_PLANTILLA = "Hacer el test";

const rellena = (tpl, params) => tpl.replace(/\{\{(\d+)\}\}/g, (_, i) => String(params[Number(i) - 1] ?? ""));

/** Cuerpo de la plantilla del test diario: por el número compartido sale la variante _trial. */
export function textoPlantillaDiaria({ conext = true, escuela, nombre, fecha, longitud, permiso }) {
  return conext
    ? rellena(PLANTILLA_DIARIA_TRIAL, [escuela, nombre, fecha, longitud, permiso])
    : rellena(PLANTILLA_DIARIA, [nombre, fecha, longitud, permiso]);
}

// ── c_sendMessage: prefijo del número compartido (texto libre e interactivos) ──────────────────
export const prefijoConext = (escuela) => `📩 *${escuela}* te escribe:\n\n`;
export const conPrefijo = (texto, { conext, escuela }) => (conext ? `${prefijoConext(escuela)}${texto}` : texto);

// ── Preguntas de ejemplo: copiadas TAL CUAL del banco de la DGT (tests públicos, sin imagen necesaria) ──
// admin_scripts/test_teorica/dgt/muestra/banco_dgt_publico_muestra.json — el mismo que reciben los alumnos.
export const ATRIBUCION_DGT = "Fuente: Organismo Autónomo Jefatura Central de Tráfico (DGT). Disponible gratis en sede.dgt.gob.es";
const FUENTE_DGT = "dgt-publico";
export const PREGUNTAS_EJEMPLO = {
  p1: {"pregunta_id": "dgt-474e0ee0754de80f", "permiso": "B", "tema": "Centros colaboradores", "texto": "¿De qué depende la distancia de detención?", "opciones": {"a": "De la velocidad, solamente.", "b": "Del tipo de vehículo, solamente.", "c": "De la velocidad, del tiempo de reacción y de la distancia de frenado."}, "correcta": "c", "explicacion": ""},
  p2: {"pregunta_id": "dgt-99ace68ac358c491", "permiso": "B", "tema": "Circulación", "texto": "Si en un paso a nivel las barreras están en movimiento...", "opciones": {"a": "no se debe entrar.", "b": "no se debe entrar, salvo que estén levantándose y haya espacio suficiente.", "c": "se puede entrar antes de que las barreras corten el paso."}, "correcta": "a", "explicacion": ""},
  p7: {"pregunta_id": "dgt-709a112a0410ffe6", "permiso": "B", "tema": "Accidentes y emergencias", "texto": "En un turismo, ¿cuántos chalecos reflectantes es obligatorio llevar?", "opciones": {"a": "Uno por cada plaza autorizada de que disponga el vehículo.", "b": "Dos: uno para el conductor y otro para el acompañante.", "c": "Uno."}, "correcta": "c", "explicacion": ""},
  t1: {"pregunta_id": "dgt-ae263a783cfab399", "permiso": "B", "tema": "El conductor (factor humano)", "texto": "Bajo los efectos del alcohol, el tiempo de reacción...", "opciones": {"a": "aumenta.", "b": "no se ve afectado.", "c": "disminuye."}, "correcta": "a", "explicacion": ""},
  t2: {"pregunta_id": "dgt-1220822eab7711ba", "permiso": "B", "tema": "Tipos de vehículos", "texto": "En una autovía, el límite de velocidad para una motocicleta es de...", "opciones": {"a": "120 km/h.", "b": "100 km/h.", "c": "120 km/h, pudiéndose superar en 20 km/h para adelantar."}, "correcta": "a", "explicacion": ""},
  e1: {"pregunta_id": "dgt-8047b0a22107fc83", "permiso": "B", "tema": "Circulación", "texto": "En los pasos para peatones y en sus proximidades, ¿está permitido adelantar?", "opciones": {"a": "Sí; a velocidad reducida, para poder detener el vehículo en caso de peligro de atropello.", "b": "Sí, siempre que no haya peatones cruzando.", "c": "No, nunca."}, "correcta": "a", "explicacion": ""},
  e2: {"pregunta_id": "dgt-ee2d842bf7e12c74", "permiso": "B", "tema": "Factores climatológicos y ambientales", "texto": "Cuando existan placas de hielo en la calzada, ¿cuál es la forma más aconsejable y segura de descender una pendiente prolongada?", "opciones": {"a": "Con marchas cortas para frenar lo menos posible.", "b": "Reduciendo la velocidad con el freno de mano, especialmente al trazar las curvas.", "c": "Con marchas largas para mejorar el agarre de las ruedas motrices."}, "correcta": "a", "explicacion": ""},
  e3: {"pregunta_id": "dgt-9bd99a2904f354f0", "permiso": "B", "tema": "El conductor (factor humano)", "texto": "El nivel de atención de un conductor, ¿disminuye cuando utiliza el teléfono móvil?", "opciones": {"a": "Sí, aunque utilice un dispositivo de manos libres.", "b": "No; hablar por teléfono no afecta a la atención del conductor.", "c": "Solo si no utiliza un sistema de manos libres o si escribe un mensaje de texto."}, "correcta": "a", "explicacion": ""},
  e4: {"pregunta_id": "dgt-1db193b800e31546", "permiso": "B", "tema": "Partes del vehículo", "texto": "Los turismos, ¿están obligados a llevar espejo retrovisor izquierdo?", "opciones": {"a": "No, es opcional.", "b": "Sí, es obligatorio.", "c": "Solo si el retrovisor interior no permite una visión completa de la vía."}, "correcta": "b", "explicacion": ""},
  e5: {"pregunta_id": "dgt-5b7fa62b7736afc4", "permiso": "B", "tema": "Luces y advertencias ópticas", "texto": "Un turismo que circula entre la puesta y la salida del sol, ¿debe llevar iluminadas las placas de matrícula?", "opciones": {"a": "Sí, tanto la placa delantera como la trasera.", "b": "Solo la placa trasera.", "c": "Solo la placa delantera."}, "correcta": "b", "explicacion": ""},
};

// Imagen de cada pregunta de ejemplo (la misma del banco de la DGT), servida desde public/ de la app:
// el Flow la pinta entre el tema y el enunciado (Image, alto 180, contain) y Telegram la manda como foto.
export const IMAGEN_EJEMPLO = {
  p1: "/test-teorica/ejemplo/MT42661_8ec3670562.jpg",
  p2: "/test-teorica/ejemplo/FV2770_c3b9744f06.jpg",
  p7: "/test-teorica/ejemplo/FV1179_ef0c3370f5.jpg",
  t1: "/test-teorica/ejemplo/FV0780_4a4782c98f.jpg",
  t2: "/test-teorica/ejemplo/FV4212_d047288e45.jpg",
  e1: "/test-teorica/ejemplo/FV0496_ef6cbf085c.jpg",
  e2: "/test-teorica/ejemplo/MT46266_4751dae4cd.jpg",
  e3: "/test-teorica/ejemplo/MT36014_b4888f6c7c.jpg",
  e4: "/test-teorica/ejemplo/MT45390_a4f12d1aa7.jpg",
  e5: "/test-teorica/ejemplo/FV5321_317b322356.jpg",
};

const conClave = (id) => ({ ...PREGUNTAS_EJEMPLO[id], key: `dgt#B#${PREGUNTAS_EJEMPLO[id].pregunta_id}`, fuente: FUENTE_DGT });

/**
 * Un test de ejemplo de `longitud` preguntas: acierta la 1.ª (p1), falla la 2.ª (p2, marca B) y
 * la 7.ª (p7, marca A), y acierta el resto. Devuelve todo lo que pintan las vistas previas, con los
 * MISMOS constructores que el backend.
 */
export function ejemploTest({ longitud = 10, demo = false, permiso = "B" } = {}) {
  const total = LONGITUDES.includes(Number(longitud)) ? Number(longitud) : 10;
  const p1 = conClave("p1");
  const p2 = conClave("p2");
  const p7 = conClave("p7");
  const test_id = "t20261002T2000_ej3mpl";
  const preguntas = Array.from({ length: total }, (_, i) => {
    if (i === 0) return { k: p1.key, c: p1.correcta, r: p1.correcta, t: p1.tema };
    if (i === 1) return { k: p2.key, c: p2.correcta, r: "b", t: p2.tema };
    if (i === 6) return { k: p7.key, c: p7.correcta, r: "a", t: p7.tema };
    return { k: `dgt#B#x${i + 1}`, c: "a", r: "a", t: "Teórica" };
  });
  const test = { test_id, permiso, demo, preguntas, atribuciones: [ATRIBUCION_DGT] };
  const porKey = { [p1.key]: p1, [p2.key]: p2, [p7.key]: p7 };
  const correccion = corregir(preguntas);
  return {
    test, porKey, correccion, total,
    pregunta1: pantallaPregunta({ k: 1, total, test_id, pregunta: p1 }),
    pregunta2: pantallaPregunta({ k: 2, total, test_id, pregunta: p2 }),
    imagen1: IMAGEN_EJEMPLO.p1,
    imagen2: IMAGEN_EJEMPLO.p2,
    respuestas: { 1: p1.correcta, 2: "b" },
    resultado: pantallaResultado({ test, porKey, demo }),
    notaWhatsApp: textoResultadoWhatsApp({ test, correccion, porKey, demo }),
  };
}

/** Lo que ve el alumno por Telegram: la 1.ª ya contestada (mensaje editado) y la 2.ª con sus botones. */
export function ejemploTelegram({ longitud = 10, demo = false } = {}) {
  const total = LONGITUDES.includes(Number(longitud)) ? Number(longitud) : 10;
  const test_id = "t20261002T2000_ej3mpl";
  const q1 = { ...PREGUNTAS_EJEMPLO.t1, fuente: FUENTE_DGT };
  const q2 = { ...PREGUNTAS_EJEMPLO.t2, fuente: FUENTE_DGT };
  const pendiente = mensajePregunta({ test_id, idx: 1, total, pregunta: q2, conImagen: true });
  const preguntas = Array.from({ length: total }, (_, i) => ({ k: `k${i}`, c: "b", r: i === 1 || i === 4 ? "a" : "b" }));
  return {
    contestada: textoPreguntaCorregida({ test_id, idx: 0, total, pregunta: q1, respuesta: q1.correcta }),
    pendiente: { text: pendiente.text, botones: pendiente.reply_markup.inline_keyboard[0].map((b) => b.text), img: IMAGEN_EJEMPLO.t2 },
    imagenContestada: IMAGEN_EJEMPLO.t1,
    fallada: textoPreguntaCorregida({ test_id, idx: 1, total, pregunta: q2, respuesta: "b" }),
    final: textoFinal({ correccion: corregir(preguntas), racha: 3, demo, atribucion: ATRIBUCION_DGT }),
  };
}

/** De la respuesta de GET …/tests/{test_id} (ficha) a lo que recibió el alumno. */
export function recibidoPorAlumno(detalle) {
  const preguntas = (detalle && Array.isArray(detalle.preguntas) ? detalle.preguntas : []);
  const test = { preguntas: preguntas.map((p) => ({ k: String(p.n), c: p.correcta, r: p.respuesta || null })) };
  const porKey = Object.fromEntries(preguntas.map((p) => [String(p.n), { texto: p.texto, opciones: p.opciones || {}, explicacion: p.explicacion || "" }]));
  const correccion = corregir(test.preguntas);
  const demo = !!detalle?.demo;
  if (detalle?.canal === "telegram") {
    const total = preguntas.length;
    const falladas = preguntas
      .map((p, idx) => ({ p, idx }))
      .filter(({ p }) => p.respuesta && p.respuesta !== p.correcta)
      .slice(0, 2)
      .map(({ p, idx }) => textoPreguntaCorregida({
        test_id: "t", idx, total, respuesta: p.respuesta,
        pregunta: { tema: p.tema, texto: p.texto, opciones: p.opciones || {}, correcta: p.correcta, explicacion: p.explicacion, fuente: p.fuente },
      }));
    return { canal: "telegram", mensajes: [...falladas, textoFinal({ correccion, demo })] };
  }
  return { canal: "whatsapp", mensajes: [textoResultadoWhatsApp({ test, correccion, porKey, demo })] };
}

// ── Test INTERACTIVO de la vista previa (el alumno contesta de verdad) ──────────────────────────
// Diez preguntas reales del banco de la DGT. Un test de 20 o 30 en la vista previa las repite (el alumno
// de verdad nunca ve una pregunta dos veces en el mismo test): lo dice la guía bajo el móvil.
export const POOL_EJEMPLO = ["p1", "p2", "t1", "e1", "p7", "e2", "t2", "e3", "e4", "e5"];
const deEjemplo = (n) => conClave(POOL_EJEMPLO[(n - 1) % POOL_EJEMPLO.length]);
const idDe = (n) => POOL_EJEMPLO[(n - 1) % POOL_EJEMPLO.length];
export const imagenDe = (n) => IMAGEN_EJEMPLO[idDe(n)] || null;
export const TEST_ID_EJEMPLO = "t20261005T2000_ej3mpl";

/** Pantalla P_xx de la pregunta n (1…total) del test interactivo. */
export function preguntaInteractiva(n, total) {
  return pantallaPregunta({ k: n, total, test_id: TEST_ID_EJEMPLO, pregunta: deEjemplo(n) });
}

/**
 * El test terminado con lo que ha contestado el alumno ({ n: "a"|"b"|"c" }). Con `rellenar`, las que no ha
 * contestado se contestan de ejemplo (aciertos salvo la 4.ª y la 9.ª de cada diez), para ver la nota sin
 * hacer las 30. Devuelve la pantalla RESULTADO y la nota que le llega por WhatsApp al cerrar.
 */
export function resultadoInteractivo(respuestas, total, { rellenar = false, demo = false } = {}) {
  const porKey = {};
  const preguntas = Array.from({ length: total }, (_, i) => {
    const n = i + 1;
    const q = deEjemplo(n);
    porKey[q.key] = q;
    const ejemplo = n % 10 === 4 || n % 10 === 9 ? ["a", "b", "c"].find((l) => l !== q.correcta) : q.correcta;
    const r = respuestas[n] || (rellenar ? ejemplo : null);
    return { k: q.key, c: q.correcta, r, t: q.tema };
  });
  const test = { test_id: TEST_ID_EJEMPLO, permiso: "B", demo, preguntas, atribuciones: [ATRIBUCION_DGT] };
  const correccion = corregir(preguntas);
  return {
    correccion,
    resultado: pantallaResultado({ test, porKey, demo }),
    notaWhatsApp: textoResultadoWhatsApp({ test, correccion, porKey, demo }),
  };
}

// ── Telegram interactivo (c_testTeoricaTelegram/telegramHandler.js) ─────────────────────────────
export const TG_BOT_URL = "https://t.me/ConextTestsBot";
export const TG_AYUDA = "/test — hacer un test ahora\n/pausa — dejar de recibir el test diario un tiempo\n/reanudar — volver a recibirlo\n/stop — darte de baja";
export const TG_TEXTOS = {
  stop: "Hecho: ya no te mandaré más tests. Si quieres volver, escribe /reanudar.",
  pausa: "Tests en pausa. Escribe /reanudar cuando quieras seguir.",
  reanudar: ({ frecuencia, hora }) => (frecuencia === "diaria" ? `Hecho. El próximo test te llega a las ${hora}:00.` : "Hecho. Escribe /test cuando quieras uno."),
  baja: "Te diste de baja. Escribe /reanudar para volver.",
};

/** El saludo al abrir el enlace del Flow (vincular). */
export function bienvenidaTelegram({ nombre, escuela, frecuencia = "diaria", longitud, hora }) {
  const cuando = frecuencia === "diaria" ? `Te mandaré un test de ${longitud} preguntas cada día a las ${hora}:00.` : "Pide un test cuando quieras con /test.";
  return `Hola${nombre ? ` ${esc(nombre)}` : ""}. Ya estás conectado a los tests de teórica${escuela ? ` de <b>${esc(escuela)}</b>` : ""}.\n\n${cuando}\n\n${TG_AYUDA}`;
}

/** La pregunta n por Telegram (foto con el texto de pie y botones A, B, C). */
export function preguntaTelegram(n, total) {
  const m = mensajePregunta({ test_id: TEST_ID_EJEMPLO, idx: n - 1, total, pregunta: deEjemplo(n), conImagen: !!imagenDe(n) });
  return { text: m.text, botones: m.reply_markup.inline_keyboard[0].map((b) => b.text), img: imagenDe(n) };
}

/** La misma pregunta editada al contestarla (sin botones, con la corrección debajo). */
export const preguntaTelegramCorregida = (n, total, respuesta) =>
  textoPreguntaCorregida({ test_id: TEST_ID_EJEMPLO, idx: n - 1, total, pregunta: deEjemplo(n), respuesta });

/** Nota final por Telegram. */
export function finalTelegram(respuestas, total, { rellenar = false } = {}) {
  const { correccion } = resultadoInteractivo(respuestas, total, { rellenar });
  return textoFinal({ correccion, racha: 0, atribucion: ATRIBUCION_DGT });
}
